import { jsx } from 'react/jsx-runtime';
import { useRef, useState } from 'react';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgThreeDots } from '../../../../shared/assets/three-dots.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import '../../../../context/DynamicContext/DynamicContext.js';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import { Icon } from '../../../../components/Icon/Icon.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { IconButton } from '../../../../components/IconButton/IconButton.js';
import { DotsMenuWrapper } from '../DotsMenuWrapper/DotsMenuWrapper.js';
import { DotsMenuDropdown } from '../DotsMenuDropdown/DotsMenuDropdown.js';
import { useWidgetContext } from '../../context/DynamicWidgetContext.js';

const MENU_HEIGHT = 90;
const DotsMenu = ({ options, title, buttonClassName }) => {
    const dotsMenuRef = useRef(null);
    const [showMenu, setShowMenu] = useState(false);
    const [alignment, setAlignment] = useState('bottom');
    const { availableWalletsContainerRef } = useWidgetContext();
    const onClose = () => {
        setShowMenu(false);
    };
    const handleOpenClick = (event) => {
        var _a, _b;
        event.stopPropagation();
        const availableWalletsContainerBouding = (_a = availableWalletsContainerRef === null || availableWalletsContainerRef === void 0 ? void 0 : availableWalletsContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const dotsMenuBounding = (_b = dotsMenuRef === null || dotsMenuRef === void 0 ? void 0 : dotsMenuRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        if (availableWalletsContainerBouding && dotsMenuBounding) {
            if (dotsMenuBounding.top + MENU_HEIGHT <
                availableWalletsContainerBouding.bottom) {
                setAlignment('bottom');
            }
            else if (dotsMenuBounding.top + MENU_HEIGHT >
                availableWalletsContainerBouding.top) {
                setAlignment('top');
            }
        }
        setShowMenu(!showMenu);
    };
    return (jsx(DotsMenuWrapper, Object.assign({ onClose: onClose, showMenu: showMenu, title: title, content: jsx(DotsMenuDropdown, { options: options }), alignment: alignment }, { children: jsx(IconButton, Object.assign({ ref: dotsMenuRef, onClick: handleOpenClick, "data-testid": 'dotsMenu', className: buttonClassName }, { children: jsx(Icon, Object.assign({ color: 'text-primary' }, { children: jsx(SvgThreeDots, {}) })) })) })));
};

export { DotsMenu };
